<div
  class="grid grid-flow-col gap-1 items-center justify-start px-3 py-1 bg-neutrals-0 border-neutrals-400 rounded-[4px]"
  *ngIf="user"
>
  <div
    class="bg-neutrals-900 flex justify-center items-center flex-col w-5 h-5 rounded-[20px]"
  >
    <ui-paragraph
      class="mt-[2px]"
      type="p8"
      mobile-type="p8"
      text-color="neutrals-0"
      font-weight="bold"
      [content]="initials"
    />
  </div>
  <ui-paragraph
    type="p12"
    mobile-type="p12"
    text-color="neutrals-700"
    [content]="user"
  />
</div>
